/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { log } from 'utils/logger';
import {
    DISPLAY_SCREEN
} from 'redux/actions/screen_status';



/* ========== ~~~~~~~~~~ SCREEN STATUS : REDUCER ~~~~~~~~~~ ========== */
// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components
const screenStatus = (state = {}, action) => {
    let newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case DISPLAY_SCREEN:
            const { name, visible } = action.screen;

            // handle out of content screen interuption
            if(name === 'validation' && state.name === 'outOfContent') {
                const { name, type, visible, content } = action.screen;
                const stored = { ...state };
                stored.stored = null;
                return { name, type, visible, content, stored }
            } else if(name === 'validation' && !visible) {
                return { ...state.stored }
            }

            // Prevent accidental screen replacement. OptIn screen takes precedence over all of the other screens.
            if(name !== 'optIn' && !!state.name && state.name !== name) return state;

            const initialState = { name: null, type: null, visible: null, content: null, stored: null };

            return visible ? action.screen : initialState;
        default:
            return state;
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default screenStatus;





